import { Link, NavLink } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { useState } from 'react'

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false)

  const navLinkClass = ({ isActive }) => 
    `text-xs font-mono tracking-widest uppercase transition-all duration-300 relative py-2 ${
      isActive 
        ? 'text-white drop-shadow-[0_0_8px_rgba(255,255,255,0.5)]' 
        : 'text-hs-text/60 hover:text-white'
    }`

  const activeIndicator = "absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-hs-core to-transparent shadow-[0_0_8px_#4F98FF]"

  return (
    <nav className="fixed w-full top-0 z-50 transition-all duration-300 bg-hs-bg/60 backdrop-blur-2xl border-b border-white/[0.05] shadow-lg shadow-black/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20">
        <div className="flex items-center justify-between h-full">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 neu-panel rounded-full flex items-center justify-center shadow-neu-out-sm border-white/10 group-hover:shadow-glossy transition-all">
              <span className="font-display font-bold text-lg text-gloss">H</span>
            </div>
            <span className="text-xl font-display font-bold text-white tracking-tight flex items-center drop-shadow-md">
              <span className="text-hs-border mx-2 font-light">|</span> <span className="text-hs-text/90 font-light tracking-widest">STUDIO</span>
              <span className="ml-3 px-2 py-0.5 text-[9px] font-mono font-bold uppercase tracking-widest shadow-neu-in-deep bg-black/50 text-hs-core border border-hs-core/20 rounded-md">Beta</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <NavLink to="/" className={navLinkClass}>
              {({ isActive }) => (
                <>
                  Home
                  {isActive && <div className={activeIndicator} />}
                </>
              )}
            </NavLink>
            <NavLink to="/dashboard" className={navLinkClass}>
              {({ isActive }) => (
                <>
                  Dashboard
                  {isActive && <div className={activeIndicator} />}
                </>
              )}
            </NavLink>
            <a href="#tools" className="text-hs-text/60 hover:text-white transition-colors text-xs font-mono tracking-widest uppercase py-2">
              Tools
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 neu-panel rounded-full flex items-center justify-center text-white active:shadow-neu-in border-white/10"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-hs-surface/95 backdrop-blur-3xl border-b border-white/[0.05] shadow-2xl">
          <div className="px-6 py-6 space-y-6">
            <NavLink
              to="/"
              className={navLinkClass}
              onClick={() => setIsOpen(false)}
            >
              Home
            </NavLink>
            <NavLink
              to="/dashboard"
              className={navLinkClass}
              onClick={() => setIsOpen(false)}
            >
              Dashboard
            </NavLink>
          </div>
        </div>
      )}
    </nav>
  )
}
